import { html, when } from '@microsoft/fast-element';
import { eventDetail } from '../../utils/formatting';
import type { Execution } from './execution';

export const ExecutionTemplate = html<Execution>`
  <div class="header">
    <h2 class="${(x) => (x.shouldShowTimeBar && x.isVisible ? '' : 'with-bottom-margin')}">
      ${(x) => (x.shouldShowTimeBar && x.isVisible ? 'Execution Deadline' : 'Executed Contracts')}
    </h2>
    ${when(
      (x) => x.shouldShowTimeBar && x.isVisible,
      html`
        <timer-bar
          :startBarColor="#C7FF8C"
          :stopBarColor="#C0AB42"
          :spentBarColor="#3C3C3C"
          :showSeconds="false"
        ></timer-bar>
      `
    )}
  </div>
  <execution-card
    :executionNotifications=${(x) => x.executionNotifications}
    @tabSelected="${(x, c) => x.tabSelection(eventDetail(c))}"
    @updateShouldShowTimeBar="${(x, c) => x.updateShouldShowTimeBar(eventDetail(c))}"
  ></execution-card>
`;
